import { Canvas, useFrame, useThree } from '@react-three/fiber';
import { OrbitControls, Environment, Preload, useGLTF } from '@react-three/drei';
import { Suspense, useEffect, useState } from 'react';
import { Road } from './Road';
import { Buildings } from './Buildings';
import { Cars } from './Cars';
import { Trees } from './Trees';
import { Pedestrians } from './Pedestrians';
import { TrafficLight } from './TrafficLight';

// Preload all models at startup
useGLTF.preload("/models/car.glb");
useGLTF.preload("/models/trafficlightkırmızı.glb");
useGLTF.preload("/models/trafficlight.glb");
useGLTF.preload("/models/building.glb");

const CameraLogger = () => {
  const { camera } = useThree();
  const [savedPosition, setSavedPosition] = useState([3270, 90, 90]); // Başlangıç pozisyonu

  useFrame(() => {
    console.log("Kamera Pozisyonu:", camera.position.toArray());
  });

  useEffect(() => {
    camera.position.set(...savedPosition);
  }, [savedPosition, camera]);

  return null;
};


export function Scene({ trafficLightStatus, ust_images, alt_images }) {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  return (
    <Canvas
      camera={{ position: [1, 60, -52], fov: 50 }}
      style={{ height: '100vh' }}
      shadows="soft"
      dpr={Math.min(2, window.devicePixelRatio)}
      gl={{
        antialias: false,
        powerPreference: "high-performance",
        clearColor: 'white'
      }}
      performance={{ min: 0.5 }}
    >
      <Suspense fallback={null}>
        <Environment preset="city" />
        <ambientLight intensity={0.4} />
        <directionalLight
          position={[10, 15, 5]}
          intensity={0.8}
          castShadow
          shadow-mapSize={[1024, 1024]}
          shadow-camera-far={50}
          shadow-camera-left={-20}
          shadow-camera-right={20}
          shadow-camera-top={20}
          shadow-camera-bottom={-20}
        />
        <Road />
        <Buildings />
        <Cars direction="forward" ust_images={ust_images} alt_images={alt_images} />
        <Cars direction="backward" ust_images={ust_images} alt_images={alt_images} />
        <Trees />
        <TrafficLight direction="forward" trafficLightStatus={trafficLightStatus} />
        <TrafficLight direction="backward" trafficLightStatus={trafficLightStatus} />
        <Pedestrians />
        <Preload all />
      </Suspense>
      <OrbitControls
        maxPolarAngle={Math.PI / 2.2}
        minDistance={20}
        maxDistance={80}
        enableZoom={isMobile}
        enablePan={false}
        rotateSpeed={0.5}
      />
    </Canvas>
  );
}